import { render } from "./RowScollView.vue?vue&type=template&id=0dee3ff2&scoped=true&ts=true"
import script from "./RowScollView.vue?vue&type=script&lang=ts"
export * from "./RowScollView.vue?vue&type=script&lang=ts"

import "./RowScollView.vue?vue&type=style&index=0&id=0dee3ff2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dee3ff2"]])

export default __exports__